// tslint:disable: max-line-length
import { getItem } from './../utils/localStorage';
import { groupBy } from 'lodash';
import { getStandardTypeFilterValue } from './../enums/labels/getStandardTypeFilterValue';
import { StandardFilterType } from './../enums/StandardFilterType';
import {
  CreateDataByIndexedDB,
  GetAllDataByIndexedDB,
} from './../indexed/index';
import axiosInstance from './../helpers/interceptor';
import { userHotelDetails } from './../helpers/handleBrandAndHotelData';

export const AssessmentSummaryAPI = async (
  selectedDate,
  standard = 'LQA',
  performanceClassification = 'all'
) => {
  const { selectedHotel } = userHotelDetails();

  if (standard !== 'LQA') {
    standard = 'custom' + standard;
  }

  let view = `view=category`;

  if (performanceClassification && performanceClassification !== 'all') {
    view = `view=performance&performanceClassification=${performanceClassification}`;
  }
  let dataD: any = [];
  const OfflineData = await GetAllDataByIndexedDB(
    `${Env.API_URL}/customer/hotel-assessment-summary/${selectedHotel}?&${view}&standard=${standard}&toDate=${selectedDate}&isClientApp=true`,
    selectedHotel
  );
  if (OfflineData) {
    dataD = OfflineData;
  } else {
    const { data } = await axiosInstance.get(
      `${Env.API_URL}/customer/hotel-assessment-summary/${selectedHotel}?&${view}&standard=${standard}&toDate=${selectedDate}&isClientApp=true`
    );
    dataD = data;
    CreateDataByIndexedDB(
      `${Env.API_URL}/customer/hotel-assessment-summary/${selectedHotel}?&${view}&standard=${standard}&toDate=${selectedDate}&isClientApp=true`,
      data,
      selectedHotel
    );
  }

  const modData = [...dataD.data];

  const groupedData = groupBy(modData, 'parentId');

  const categories = modData.filter((m) => m.categoryType === 'category');
  const realData = categories.map((category) => {
    if (groupedData[category.id]) {
      category.subCategory = groupedData[category.id];
    }
    return category;
  });
  return { ...dataD, data: realData };
};

export const SelfAssessmentSummaryAPI = async (
  assessmentId,
  standard,
  performanceClassification = 'all'
) => {
  let view = `view=category`;

  if (performanceClassification && performanceClassification !== 'all') {
    view = `view=performance&performanceClassification=${performanceClassification}`;
  }
  let dataD: any = [];
  const { data } = await axiosInstance.get(
    `${Env.API_URL}/customer/hotel-assessment-summary/${assessmentId}/assessment-summary?&${view}&standard=${[1, 2, 3, '1', '2', '3'].includes(standard) ? getStandardTypeFilterValue(standard) : 'LQA'}&self=1`
  );
  dataD = data;

  const modData = [...dataD.data];

  const groupedData = groupBy(modData, 'parentId');

  const categories = modData.filter((m) => m.categoryType === 'category');
  const realData = categories.map((category) => {
    if (groupedData[category.id]) {
      category.subCategory = groupedData[category.id];
      category.assessmentId = assessmentId;
    }
    return category;
  });
  return { ...dataD, data: realData };
};

export const SelfAssessmentSummaryAPIViewScreen = async (
  assessmentId,
  standard,
  performanceClassification = 'all'
) => {
  let view = `view=category`;

  if (performanceClassification && performanceClassification !== 'all') {
    view = `view=performance&performanceClassification=${performanceClassification}`;
  }

  const { data } = await axiosInstance.get(
    `${Env.API_URL}/customer/hotel-assessment-summary/${assessmentId}/view-score?&${view}&standard=${[1, 2, 3, '1', '2', '3'].includes(standard) ? getStandardTypeFilterValue(standard) : 'LQA'}&self=1`
  );

  return data;
};

export const starEmployess = async (selectedDate) => {
  const { selectedHotel } = userHotelDetails();
  let dataD: any = [];
  const OfflineData = await GetAllDataByIndexedDB(
    `${Env.API_URL}/customer/hotel-assessment-summary/${selectedHotel}/starEmployees?&toDate=${selectedDate}&standard=LQA&view=category`,
    selectedHotel
  );
  if (OfflineData) {
    dataD = OfflineData;
  } else {
    const { data } = await axiosInstance.get(
      `${Env.API_URL}/customer/hotel-assessment-summary/${selectedHotel}/starEmployees?&toDate=${selectedDate}&standard=LQA&view=category`
    );
    dataD = data;
    CreateDataByIndexedDB(
      `${Env.API_URL}/customer/hotel-assessment-summary/${selectedHotel}/starEmployees?&toDate=${selectedDate}&standard=LQA&view=category`,
      data,
      selectedHotel
    );
  }
  return dataD;
};

export const getPerformance = async (selectedDate, standard) => {
  const { selectedHotel } = userHotelDetails();
  const hasAssessment = getItem('hasAssessment');
  const selfAssessId = getItem('selfAssessment') || undefined;
  // tslint:disable-next-line:triple-equals
  let apiUrl = `${Env.API_URL}/customer/hotel-assessment-summary/${selectedHotel}?&view=performance&standard=${standard && standard != StandardFilterType.LQA ? getStandardTypeFilterValue(standard) : StandardFilterType.LQA}&toDate=${selectedDate}`;
  if (!hasAssessment && selfAssessId) {
    apiUrl += `&self=${selfAssessId}&assessmentId=${selfAssessId}`;
  }
  let dataD: any = [];
  const OfflineData = await GetAllDataByIndexedDB(apiUrl, selectedHotel);
  if (OfflineData) {
    dataD = OfflineData;
  } else {
    const { data } = await axiosInstance.get(apiUrl);
    dataD = data.data;
    CreateDataByIndexedDB(apiUrl, dataD, selectedHotel);
  }
  return dataD;
};

export const getAssessmentAttachments = async (assId) => {
  const { data } = await axiosInstance.get(
    `${Env.API_URL}/customer/hotel-assessment-summary/${assId}/assessment-attachments`
  );
  return data;
};
